import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/sewingmachine.png")